module.exports = __webpack_public_path__ + "img/ico_upload.4fcef525.svg";